<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { computed, useSlots } from 'vue'
import AgentMarkdown from '../AgentMarkdown.vue'
import { cn } from '../utils'

interface Props {
  content?: string
  variant?: 'assistant' | 'user'
  class?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'assistant',
})

const slots = useSlots()
const slotContent = computed<string | undefined>(() => {
  const nodes = slots.default?.()
  if (!Array.isArray(nodes)) {
    return undefined
  }
  let text = ''
  for (const node of nodes) {
    if (typeof node.children === 'string') text += node.children
  }
  return text || undefined
})

const md = computed(() => (slotContent.value ?? props.content ?? '') as string)
</script>

<template>
  <AgentMarkdown
    :content="md"
    :variant="props.variant"
    :class="cn(props.class)"
    v-bind="$attrs"
  />
</template>
